import { REFERENTIEL_ACCUEIL, type ReferentielAccueil, type TypeDemande } from './referentiel.js';

export interface SaisieEntretien {
  typeDemande: TypeDemande | '';
  proprietaireOrigine: string;
  /** `AAAA` ou `AAAA-MM-JJ`. */
  dateNaissanceProprietaire: string;
  /** « Qui est venu vous voir ? » (code de PREMIER_CONTACT), facultatif ; posé quand l'accueil crée le dossier. */
  venuPar?: string;
}

export interface BilanEntretien {
  valide: boolean;
  erreurs: Partial<Record<keyof SaisieEntretien, string>>;
  alerteAncien: string | null;
}

export const SAISIE_VIDE: SaisieEntretien = { typeDemande: '', proprietaireOrigine: '', dateNaissanceProprietaire: '', venuPar: '' };

const FORMAT_DATE = /^(\d{4})(?:-(\d{2})-(\d{2}))?$/;

function dateExiste(annee: number, mois: number, jour: number): boolean {
  const d = new Date(Date.UTC(annee, mois - 1, jour));
  return d.getUTCFullYear() === annee && d.getUTCMonth() === mois - 1 && d.getUTCDate() === jour;
}

/** Contrôle l'entretien initial (#38) et lève l'alerte « titre ancien » (PAR-36) d'après le référentiel. */
export function controlerEntretien(
  saisie: SaisieEntretien,
  aujourdhui: string,
  ref: ReferentielAccueil = REFERENTIEL_ACCUEIL,
): BilanEntretien {
  const erreurs: BilanEntretien['erreurs'] = {};
  if (!ref.types.some((t) => t.code === saisie.typeDemande)) {
    erreurs.typeDemande = 'Indiquez s’il s’agit d’une succession ou d’une régularisation de terrain.';
  }
  if (saisie.proprietaireOrigine.trim() === '') erreurs.proprietaireOrigine = 'Indiquez le propriétaire d’origine du bien.';

  let alerteAncien: string | null = null;
  const brute = saisie.dateNaissanceProprietaire.trim();
  const m = FORMAT_DATE.exec(brute);
  if (brute === '') {
    erreurs.dateNaissanceProprietaire = 'Indiquez la date de naissance du propriétaire d’origine, même approximative (l’année suffit).';
  } else if (!m || (m[2] !== undefined && !dateExiste(Number(m[1]), Number(m[2]), Number(m[3])))) {
    erreurs.dateNaissanceProprietaire = 'Cette date n’est pas lisible. Saisissez l’année (1932) ou la date complète (1932-05-04).';
  } else if (brute > aujourdhui.slice(0, brute.length)) {
    erreurs.dateNaissanceProprietaire = 'Cette date est dans le futur. Vérifiez-la avant de continuer.';
  } else if (Number(m[1]) < ref.seuilTitreAncienAnnee) {
    alerteAncien = ref.alerteTitreAncien;
  }
  return { valide: Object.keys(erreurs).length === 0, erreurs, alerteAncien };
}
